(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-text"] && !Shopify.designMode) return;
  try {
    
    const sections = {};

    class ReadMore {
      constructor(container) {
        this.container = container;
        this.button = this.container.querySelector('[data-read-more-button]');
        this.wrapper = this.container.querySelector('[data-text-wrapper]');
        if (!this.button || !this.wrapper) return;

        this.readMoreText = 'Read more';
        this.readLessText = 'Read less';

        this.toggle = this.toggle.bind(this);
        this.init();
      }

      init() {
        this.button.addEventListener('click', this.toggle);
      }

      toggle() {
        const isTruncated = this.wrapper.classList.contains('text-content--truncated');
        if (isTruncated) {
          this.wrapper.style.maxHeight = `${this.wrapper.scrollHeight}px`;
          this.wrapper.classList.remove('text-content--truncated');
          this.button.textContent = this.readLessText;
        } else {
          this.wrapper.style.maxHeight = null;
          this.wrapper.classList.add('text-content--truncated');
          this.button.textContent = this.readMoreText;
        }
      }

      destroy() {
        if (this.button) {
          this.button.removeEventListener('click', this.toggle);
        }
      }
    }

    function initReadMore(section) {
      const sectionId = section.dataset.sectionId;
      if (!section || sections[sectionId]) return;

      const readMoreContainers = section.querySelectorAll('[data-read-more-container]');
      sections[sectionId] = [];
      readMoreContainers.forEach((container) => {
        sections[sectionId].push(new ReadMore(container));
      });
    }

    function unloadReadMore(section) {
      const sectionId = section.dataset.sectionId;
      if (sections[sectionId]) {
        sections[sectionId].forEach((instance) => instance.destroy());
        delete sections[sectionId];
      }
    }

    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('[data-section-type="text"]').forEach((section) => {
        initReadMore(section);
      });
    });

    if (typeof Shopify.designMode !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.dataset.sectionType === 'text') {
          unloadReadMore(event.target);
          initReadMore(event.target);
        }
      });

      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.dataset.sectionType === 'text') {
          unloadReadMore(event.target);
        }
      });
    }
  
  } catch(e) { console.error(e); }
})();
})();
